// extracted by mini-css-extract-plugin
module.exports = {"bgWrap":"MidBg_bgWrap_3fq_5","imgBg":"MidBg_imgBg_2GXua","imgBg2":"MidBg_imgBg2_20duA","videoBg":"MidBg_videoBg_2fbZh","more":"MidBg_more_sT9eo"};